import { actionTypes } from '../utils/constants';
import initialState from './initialState';

/**
 * User Reducer
 *
 * @param {object} state the state
 * @param {object} action the action that executed
 */

export default function versionInfoReducer(state = initialState.versionInfo, action){
    switch (action.type) {
        case actionTypes.VERSION_INFO_SUCCESS:
          return action.versionInfo;
        default:
          return state;
      }
}
